import { StyledFlex } from '@dreryk/react-components';

import { TimeSinceLastVisit, TimeSinceLastVisitLoader } from '~libs.desktop.shared.visit';

import { visitTranslationKeys } from '../../translations';
import { PrescriptionVisitFormController } from '../form/PrescriptionVisitForm.types';

import { getPrescriptionVisitPath } from './TimeSinceLastVisitInformation.utils';

type TimeSinceLastVisitInformationProps = Pick<PrescriptionVisitFormController, 'watch'>;

export const TimeSinceLastVisitInformation = (props: TimeSinceLastVisitInformationProps): JSX.Element | null => {
   const patient = props.watch('patient');
   const practitioner = props.watch('practitioner');

   if (!patient || !practitioner) {
      return null;
   }

   return (
      <TimeSinceLastVisitLoader patientId={patient.id} practitionerId={practitioner.practitionerId}>
         {({ timeSinceLast }) => (
            <StyledFlex direction={'column'} gap={'4px'}>
               <TimeSinceLastVisit
                  timeSinceLast={timeSinceLast}
                  getVisitPath={getPrescriptionVisitPath}
                  backActionLabel={visitTranslationKeys.goBackToPrescriptionVisit}
               />
            </StyledFlex>
         )}
      </TimeSinceLastVisitLoader>
   );
};
